import angular from 'angular';

export default function EditServerDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  bcpDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;
  vm.newServer = { ...vm.server };

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditServerFormSubmit = _handleEditServerFormSubmit;

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editServerDialog);
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleEditServerFormSubmit() {
    if ($scope.editServerForm.$invalid) {
      return Promise.resolve();
    }
    const isNew = vm.newServer.assessmentServerId < 0;

    if (!isNew && angular.equals(vm.server, vm.newServer)) {
      // No need to save
      return _closeDialog();
    }

    loaderService.showViewLoader = true;
    // vm.newServer.assessmentId = vm.assessmentId;
    return bcpDataService.saveServer(vm.assessmentId, vm.newServer)
      .then((response) => {
        const savedServer = response.data;

        angular.extend(vm.newServer, savedServer);
        angular.extend(vm.server, vm.newServer);

        $rootScope.$broadcast('setDocumentRegenerateFlag');
        $rootScope.$broadcast('refreshBCPServers');
      
        alerts.success('The Server has been saved successfully.');

        return _closeDialog();
      })
      .catch((err) => {
        console.log(err);
        alerts.error('An error occurred while saving the Server.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }
}

EditServerDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'bcpDataService',
  'loaderService',
  'ssDialogService'
];
